import { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavigationProps {
  isScrolled?: boolean;
}

export function Navigation({ isScrolled = true }: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-center w-10 h-10 rounded-lg transition-colors cursor-pointer ${
          isScrolled ? 'hover:bg-gray-100' : 'hover:bg-white/10'
        }`}
        aria-label="メニュー"
      >
        <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          ></div>
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl z-50 py-2 border border-gray-100">
            <Link
              to="/"
              className="block px-4 py-3 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              <i className="ri-home-line mr-2"></i>
              トップページ
            </Link>
            <Link
              to="/case-studies"
              className="block px-4 py-3 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              <i className="ri-image-line mr-2"></i>
              施工事例
            </Link>
            <Link
              to="/about"
              className="block px-4 py-3 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              <i className="ri-building-line mr-2"></i>
              会社概要
            </Link>
            <Link
              to="/blog"
              className="block px-4 py-3 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              <i className="ri-article-line mr-2"></i>
              ブログ
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
